/**
 * Mapeamento de agências ambientais estaduais por estado brasileiro
 * Este arquivo serve como referência e configuração para o sistema de monitoramento
 * Lista oficial fornecida pelo cliente
 */

export interface StateAgencyInfo {
  code: string;
  name: string;
  fullName: string;
  description?: string;
}

export const STATE_AGENCIES: { [stateCode: string]: StateAgencyInfo[] } = {
  // AC - Acre
  ac: [
    { code: 'sema-ac', name: 'SEMA', fullName: 'Secretaria de Estado de Meio Ambiente' },
    { code: 'imac-ac', name: 'IMAC', fullName: 'Instituto de Meio Ambiente do Acre' },
  ],
  
  // AL - Alagoas
  al: [
    { code: 'semarh-al', name: 'SEMARH', fullName: 'Secretaria do Meio Ambiente e dos Recursos Hídricos' },
    { code: 'ima-al', name: 'IMA', fullName: 'Instituto do Meio Ambiente' },
  ],
  
  // AP - Amapá
  ap: [
    { code: 'sema-ap', name: 'SEMA', fullName: 'Secretaria de Estado do Meio Ambiente' },
    { code: 'imap-ap', name: 'IMAP', fullName: 'Instituto do Meio Ambiente e Ordenamento Territorial' },
  ],
  
  // AM - Amazonas
  am: [
    { code: 'sema-am', name: 'SEMA', fullName: 'Secretaria de Estado do Meio Ambiente' },
    { code: 'ipaam-am', name: 'IPAAM', fullName: 'Instituto de Proteção Ambiental do Estado do Amazonas' },
  ],
  
  // BA - Bahia
  ba: [
    { code: 'sema-ba', name: 'SEMA', fullName: 'Secretaria do Meio Ambiente' },
    { code: 'inema-ba', name: 'INEMA', fullName: 'Instituto do Meio Ambiente e Recursos Hídricos' },
  ],
  
  // CE - Ceará
  ce: [
    { code: 'srh-ce', name: 'SRH', fullName: 'Secretaria dos Recursos Hídricos' },
    { code: 'semace-ce', name: 'SEMACE', fullName: 'Superintendência Estadual do Meio Ambiente' },
  ],
  
  // DF - Distrito Federal
  df: [
    { code: 'sema-df', name: 'SEMA', fullName: 'Secretaria do Meio Ambiente (do DF)' },
    { code: 'ibram-df', name: 'IBRAM', fullName: 'Instituto Brasília Ambiental' },
    { code: 'adasa-df', name: 'ADASA', fullName: 'Agência reguladora de águas, energia e saneamento' },
  ],
  
  // ES - Espírito Santo
  es: [
    { code: 'seama-es', name: 'SEAMA', fullName: 'Secretaria de Estado do Meio Ambiente e Recursos Hídricos' },
    { code: 'iema-es', name: 'IEMA', fullName: 'Instituto Estadual de Meio Ambiente e Recursos Hídricos' },
  ],
  
  // GO - Goiás
  go: [
    { code: 'semad-go', name: 'SEMAD', fullName: 'Secretaria de Estado de Meio Ambiente e Desenvolvimento Sustentável' },
  ],
  
  // MA - Maranhão
  ma: [
    { code: 'sema-ma', name: 'SEMA', fullName: 'Secretaria de Estado de Meio Ambiente e Recursos Naturais' },
  ],
  
  // MT - Mato Grosso
  mt: [
    { code: 'sema-mt', name: 'SEMA', fullName: 'Secretaria de Estado do Meio Ambiente' },
  ],
  
  // MS - Mato Grosso do Sul
  ms: [
    { code: 'semade-ms', name: 'SEMADE', fullName: 'Secretaria de Meio Ambiente e Desenvolvimento Econômico' },
    { code: 'imasul-ms', name: 'IMASUL', fullName: 'Instituto do Meio Ambiente de Mato Grosso do Sul' },
  ],
  
  // MG - Minas Gerais
  mg: [
    { code: 'semad-mg', name: 'SEMAD', fullName: 'Secretaria de Estado de Meio Ambiente e Desenvolvimento Sustentável' },
    { code: 'feam-mg', name: 'FEAM', fullName: 'Fundação Estadual do Meio Ambiente' },
    { code: 'igam-mg', name: 'IGAM', fullName: 'Instituto Mineiro de Gestão das Águas' },
  ],
  
  // PA - Pará
  pa: [
    { code: 'semas-pa', name: 'SEMAS', fullName: 'Secretaria de Estado de Meio Ambiente e Sustentabilidade' },
  ],
  
  // PB - Paraíba
  pb: [
    { code: 'seirhmact-pb', name: 'SEIRHMACT', fullName: 'Secretaria da Infraestrutura, Recursos Hídricos, Meio Ambiente e Ciência e Tecnologia' },
    { code: 'sudema-pb', name: 'SUDEMA', fullName: 'Superintendência de Administração do Meio Ambiente' },
  ],
  
  // PR - Paraná
  pr: [
    { code: 'sema-pr', name: 'SEMA', fullName: 'Secretaria de Estado do Meio Ambiente e Recursos Hídricos' },
    { code: 'iat-pr', name: 'IAT', fullName: 'Instituto Água e Terra' },
    { code: 'iap-pr', name: 'IAP', fullName: 'Instituto Ambiental do Paraná' },
  ],
  
  // PE - Pernambuco
  pe: [
    { code: 'apac-pe', name: 'APAC', fullName: 'Agência Pernambucana de Águas e Clima' },
    { code: 'cprh-pe', name: 'CPRH', fullName: 'Agência Estadual de Meio Ambiente' },
  ],
  
  // PI - Piauí
  pi: [
    { code: 'semar-pi', name: 'SEMAR', fullName: 'Secretaria de Meio Ambiente e Recursos Hídricos' },
  ],
  
  // RJ - Rio de Janeiro
  rj: [
    { code: 'sea-rj', name: 'SEA', fullName: 'Secretaria de Estado do Ambiente' },
    { code: 'inea-rj', name: 'INEA', fullName: 'Instituto Estadual do Ambiente' },
  ],
  
  // RN - Rio Grande do Norte
  rn: [
    { code: 'semarh-rn', name: 'SEMARH', fullName: 'Secretaria do Meio Ambiente e Recursos Hídricos' },
    { code: 'idema-rn', name: 'IDEMA', fullName: 'Instituto de Desenvolvimento Sustentável e Meio Ambiente' },
    { code: 'igarn-rn', name: 'IGARN', fullName: 'Instituto de Gestão das Águas do RN' },
  ],
  
  // RS - Rio Grande do Sul
  rs: [
    { code: 'sema-rs', name: 'SEMA', fullName: 'Secretaria do Meio Ambiente e Desenvolvimento Sustentável' },
    { code: 'fepam-rs', name: 'FEPAM', fullName: 'Fundação Estadual de Proteção Ambiental Henrique Luiz Roessler' },
  ],
  
  // RO - Rondônia
  ro: [
    { code: 'sedam-ro', name: 'SEDAM', fullName: 'Secretaria de Estado do Desenvolvimento Ambiental' },
  ],
  
  // RR - Roraima
  rr: [
    { code: 'femarh-rr', name: 'FEMARH', fullName: 'Fundação Estadual do Meio Ambiente e Recursos Hídricos' },
  ],
  
  // SC - Santa Catarina
  sc: [
    { code: 'ima-sc', name: 'IMA', fullName: 'Instituto do Meio Ambiente de Santa Catarina' },
    { code: 'fatma-sc', name: 'FATMA', fullName: 'Fundação do Meio Ambiente' },
  ],
  
  // SP - São Paulo
  sp: [
    { code: 'sma-sp', name: 'SMA', fullName: 'Secretaria do Meio Ambiente' },
    { code: 'cetesb-sp', name: 'CETESB', fullName: 'Companhia Ambiental do Estado de São Paulo' },
    { code: 'daee-sp', name: 'DAEE', fullName: 'Departamento de Águas e Energia Elétrica' },
  ],
  
  // SE - Sergipe
  se: [
    { code: 'semarh-se', name: 'SEMARH', fullName: 'Secretaria de Estado do Meio Ambiente e Recursos Hídricos' },
    { code: 'adema-se', name: 'ADEMA', fullName: 'Administração Estadual do Meio Ambiente' },
  ],
  
  // TO - Tocantins
  to: [
    { code: 'semarh-to', name: 'SEMARH', fullName: 'Secretaria do Meio Ambiente e Recursos Hídricos' },
  ],
};

/**
 * Retorna as agências disponíveis para um estado específico
 */
export function getAgenciesByState(stateCode: string): StateAgencyInfo[] {
  return STATE_AGENCIES[stateCode.toLowerCase()] || [];
}

/**
 * Retorna todos os estados que têm agências configuradas
 */
export function getStatesWithAgencies(): string[] {
  return Object.keys(STATE_AGENCIES);
}

/**
 * Retorna informações de uma agência específica pelo código
 */
export function getAgencyInfo(agencyCode: string): StateAgencyInfo | null {
  for (const agencies of Object.values(STATE_AGENCIES)) {
    const found = agencies.find(a => a.code === agencyCode);
    if (found) return found;
  }
  return null;
}

